/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React, {Component} from 'react';
// material
import SubPage from 'material/structure/subpage/subpage';
import Group from 'material/group/group';
import Tip from 'material/message/tip/tip';
// import Form from 'material/form/form_container';
import Field from 'material/form/field/field_container';
import SearchableDropDown from 'material/dropdowns/searchabledropdown/searchabledropdown';
import Grid from 'material/grid/grid';
import GridSet from 'material/grid/gridset/gridset';
import GridItem from 'material/grid/griditem/griditem';
import Copy from 'material/copy/copy';
import Title from 'material/copy/title/title';
import CTAs from 'material/ctas/ctas';
import Button from 'material/ctas/button/button';
import AdsTxtIndicator from 'pages/dashboard/account/adstxt/adstxtindicator/adstxtindicator_container';
// utils
import { downloadTxtFile } from 'utils/downloadFiles';
// styles
import injectSheet from 'react-jss';
import styles from 'pages/dashboard/account/adstxt/adstxt_styles';



/* ========== ~~~~~~~~~~ Adstxt : Page ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
class Adstxt extends Component {
    constructor(props){
        super(props);
        this.state={ selectedSite: null, sortedAdsTxtValues: "" } ;
    }

    componentDidMount(){
        if(Object.keys(this.props.sites).length){
            this.fetchFirstSitesAdsTxt()
        }
    }

    componentDidUpdate(prevProps){
        if(Object.keys(prevProps.sites).length !== Object.keys(this.props.sites).length){
            this.fetchFirstSitesAdsTxt()
        }
        if(this.props.missingElements !== prevProps.missingElements){
            this.setState({sortedAdsTxtValues: this.sortAdsTxtValues()})
        }
    }

    fetchFirstSitesAdsTxt = () => {
        let firstSite = {name: this.props.sites[Object.keys(this.props.sites)[0]], value: Object.keys(this.props.sites)[0]};
        this.props.getAdsTxt(`?clientUUID=${this.props.accountUUID}&siteUUID=${firstSite.value}`, firstSite);
    };

    highlightedValues = ()=>{
        return this.state.sortedAdsTxtValues.split('\n').map((item, index)=>{
            return <mark key={index} className={this.props.missingElements.indexOf(item)>=0 ? 'missing' : 'present'} >{item}</mark>
        })
    };

    handleIndicator = () => this.props.containsAdsTxt !== null ? <AdsTxtIndicator containsAdsTxt={this.props.containsAdsTxt} installed={this.props.adsTxtComplete}/> : null;

    handleSiteInDropDown = () => {
        let sites = [];
        Object.keys(this.props.sites).forEach( (item) => {
            sites.push({value: item, name: this.props.sites[item]})
        });

        return sites
    };

    handleAdsTxtFetch = (site) =>{
        this.props.getAdsTxt(`?clientUUID=${this.props.accountUUID}&siteUUID=${site.value}`, site);
        this.setState({selectedSite: site})
    };

    handleAdsTxtVerify = () => {
        this.props.verifyAdsTxt(`?clientUUID=${this.props.accountUUID}&siteUUID=${this.props.selectedSite.value}&siteUrl=${encodeURIComponent(this.props.selectedSite.name)}`)
    };

    handleAdsTxtDownload = () => {
        if(this.props.adsTxtValues)downloadTxtFile('ads.txt', this.props.adsTxtValues)
    };

    sortAdsTxtValues = () => {
        let sortedAdsTxt = [];
        this.props.adsTxtValues.split('\n').map(item => this.props.missingElements.indexOf(item)>=0 ? sortedAdsTxt.unshift(item) : sortedAdsTxt.push(item));
        sortedAdsTxt = sortedAdsTxt.join('\n');
        return sortedAdsTxt;
    };


    render() {
        return (
            <SubPage name={`adstxt`} klass={this.props.classes.adstxt}>
                <Copy name={`page-copy`}>
                    <Title variant={`withtip`}>
                        <h2>Ads.txt Implementation</h2>
                        <Tip space={`left`} content={<p>An ads.txt file is a simple text file (not an Embed code) that is uploaded into your domain’s root directory. In other words, it is implemented the same way a robots.txt file on your root domain would be implemented.</p>}/>
                    </Title>
                </Copy>
                <Group name={`page-details`}>
                    {/*<Form name={`adstxt`}>*/}
                    <Grid>
                        <GridSet name={`sites-indicator`}>
                            <GridItem name={'sites'}>
                                <SearchableDropDown handleSelect={this.handleAdsTxtFetch} disabled={this.props.fetchingSites || !this.props.sitesReceived} selected={this.props.selectedSite} name={`all sites`} items={this.handleSiteInDropDown()}/>
                            </GridItem>
                            <GridItem>
                                {this.handleIndicator()}
                            </GridItem>
                        </GridSet>
                        <GridSet>
                            <GridItem name={`adstxt-values`}>
                                <div className={`backdrop loading-${this.props.adsTxtFetching || this.props.fetchingSites}`}>
                                    <div className={`highlighted-values`}>{this.highlightedValues()}</div>
                                    <Field type={`textarea`} defaultValue={(this.props.adsTxtFetching || this.props.fetchingSites) ? 'Loading...' : this.sortAdsTxtValues()}/>
                                </div>
                            </GridItem>
                        </GridSet>
                        <GridSet>
                            <GridItem name={`adstxt-ctas`}>
                                <CTAs name={`adstxt-ctas`}>
                                    <Button variant={this.props.selectedSite ? `primary` : `disabled`} type={'action'} text={`Verify Installation`} action={this.handleAdsTxtVerify}/>
                                    <Button variant={this.props.selectedSite ? `primary` : `disabled`} type={'action'} text={`Download ads.txt`} action={this.handleAdsTxtDownload}/>
                                </CTAs>
                            </GridItem>
                        </GridSet>
                    </Grid>
                </Group>
            </SubPage>
        );
    }
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// will be utilized in parent component after being infused with app state & actions
export default injectSheet(styles)(Adstxt);